import { useCallback } from 'react';
import { REDIRECT_LINK } from '@src/constants';
import { reachGoalFunk } from '@src/utils/reachGoalFunk';

export const useClickunder = () => {
  const handleClickunderButtonClick = useCallback((e: Event) => {
    e.preventDefault();
    setTimeout(() => {
      window.location.href = REDIRECT_LINK;
      reachGoalFunk('reg_2_start');
    }, 1e3);
    window.open('/sign_up', '_blank');
  }, []);

  return {
    handleClickunderButtonClick,
  };
};
